import { TopBarWrapper } from "./styled";
import Button from "../../../../../../library/button";
import Modal from "../../../../../../library/modal";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSettings } from "../../context";
import DownloadModal from "../../download-modal";
import { sendErrorNotification } from "../../../../../../library/notification";

const MobileTopBar = () => {
  const { generationProgress, isGenerating, generateVideo, videoDownloadUrl } =
    useSettings();
  const [showDownloadModal, setShowDownloadModal] = useState<boolean>(false);

  const closeDownloadModal = () => {
    setShowDownloadModal(false);
  };

  const openDownloadModal = () => {
    setShowDownloadModal(true);
  };

  const clickDownload = async () => {
    try {
      await generateVideo();
    } catch (e) {
      sendErrorNotification("Kunne ikke laste ned video.");
    }
  };

  const renderDownloadButton = () => {
    if (isGenerating) {
      return `Genererer (${generationProgress}%)`;
    } else {
      return "Last ned";
    }
  };

  useEffect(() => {
    if (videoDownloadUrl) {
      openDownloadModal();
    }
  }, [videoDownloadUrl]);

  return (
    <>
      <TopBarWrapper>
        <Link to="/dashboard/transcripts">
          <Button variant="icon" icon="back" color="grey" />
        </Link>
        <Button
          onClick={clickDownload}
          icon="download"
          variant="regular"
          size="md"
          color="blue"
        >
          {renderDownloadButton()}
        </Button>
      </TopBarWrapper>
      <Modal
        open={showDownloadModal}
        onClose={closeDownloadModal}
        title="Videoen din er ferdig"
      >
        <DownloadModal
          downloadUrl={videoDownloadUrl}
          onClose={closeDownloadModal}
        />
      </Modal>
    </>
  );
};

export default MobileTopBar;
